import { render } from "./dialog-component.vue?vue&type=template&id=078a8b4a&scoped=true"
import script from "./dialog-component.vue?vue&type=script&lang=js"
export * from "./dialog-component.vue?vue&type=script&lang=js"

import "./dialog-component.vue?vue&type=style&index=0&id=078a8b4a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078a8b4a"]])

export default __exports__